<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_Hlk61959347"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Elle Laga’aia was born to US Navy Samoan parents. She grew up between California and American Samoa. Elle lives in Southern California and is the mother of three daughters and a Siamese cat. In her waking hours, she supports and advocates for animal charities.</p>
<p class="block_3"> </p>
<p class="block_2">Elle enjoys traveling to circumnavigate the world, one country at a time.</p>
<p class="block_4" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?7f2f2ec4